import { cloneDeep } from 'lodash';

const updateNavigation = (app, template) => {
  const updatedNav = cloneDeep(app.view.navigation);
  updatedNav.components = app.view.navigation.components.map(c => {
    if (c.templateId === template.id) {
      const newComponent = cloneDeep(c);
      newComponent.title.text = template.pageName;
      return newComponent;
    }
    return c;
  });
  return updatedNav;
  // return app.view.navigation;
};

export default updateNavigation;
